var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdminNewImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.375 17.875L27.125 19.125L24.625 16.625L25.875 15.375C26 15.25 26.125 15.125 26.375 15.125C26.5 15.125 26.75 15.25 26.875 15.375L28.5 17C28.625 17.25 28.625 17.625 28.375 17.875ZM16.25 24.875V27.5H18.875L26.5 19.875L24 17.375L16.25 24.875ZM14.0125 19.7875L11.5625 16.8375L8.125 21.25H16.4L19.575 18.1875L17.45 15.3625L14.0125 19.7875ZM13.75 24.875V23.8125L13.8125 23.75H6.25V6.25H23.75V14.1375L26.25 11.725V6.25C26.25 5.58696 25.9866 4.95107 25.5178 4.48223C25.0489 4.01339 24.413 3.75 23.75 3.75H6.25C4.875 3.75 3.75 4.875 3.75 6.25V23.75C3.75 24.413 4.01339 25.0489 4.48223 25.5178C4.95107 25.9866 5.58696 26.25 6.25 26.25H13.75V24.875Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminNewImg);
export default __webpack_public_path__ + "static/media/adminNewImg.c93ac4c1f955e2b7508e4026af0fe87e.svg";
export { ForwardRef as ReactComponent };